import { jsx, css } from "@emotion/react";
import trelloColors from "./trello-colors";

//ToDo: Change name to styles-mixins.js
export default {
  verticalScrollbar: css`
    &::-webkit-scrollbar {
      height: 8px;
      width: 8px;
    }
    &::-webkit-scrollbar-thumb {
      background: #00000021;
      border-radius: 3px;
    }

    &::-webkit-scrollbar-track-piece {
      background: #0000000a;
    }
  `,
  horizontalScrollbar: css`
    &::-webkit-scrollbar {
      height: 12px;
      width: 12px;
    }
    &::-webkit-scrollbar-thumb {
      background: #fff6;
      border-radius: 3px;
    }
    &::-webkit-scrollbar-button {
      display: block;
      height: 4px;
      width: 4px;
    }
    &::-webkit-scrollbar-track-piece {
      background: rgba(0, 0, 0, 0.15);
    }
  `,
  boxShadow: css`
    box-shadow: 0 0 2px 2px ${trelloColors.N100};
  `,
};
